import { QUICK_DATE_FILTER_CUSTOM, QUICK_DATE_FILTER_ALL_TIME } from '../../common/constants';
import type { QUICK_DATE_FILTER, UiState, ZoomState } from '../../common/types';
import pureAction from '../../common/utils/pure-sweet-state';
import { getQuickDateFilterZoomState } from './utils';

export const setZoomState = pureAction<UiState, [ZoomState]>((zoomState) => () => {
	const quickFilter =
		zoomState.type === 'percentage' && zoomState.start === 0 && zoomState.end === 100
			? QUICK_DATE_FILTER_ALL_TIME
			: QUICK_DATE_FILTER_CUSTOM;

	return {
		zoomState,
		quickFilter,
	};
});

export const setZoomStartDate = pureAction<UiState, [Date | null]>((start) => (state) => {
	// @ts-expect-error - TS2339 - Property 'endValue' does not exist on type 'ZoomState'.
	if (state.zoomState.endValue == null && start == null) {
		return {
			zoomState: {
				type: 'none',
			},
			quickFilter: QUICK_DATE_FILTER_ALL_TIME,
		};
	}

	return {
		zoomState: {
			type: 'value',
			startValue: start != null ? start.getTime() : null,
			endValue:
				// @ts-expect-error - TS2339 - Property 'endValue' does not exist on type 'ZoomState'. | TS2339 - Property 'endValue' does not exist on type 'ZoomState'.
				state.zoomState.endValue != null ? state.zoomState.endValue : new Date().getTime(),
		},
		quickFilter: QUICK_DATE_FILTER_CUSTOM,
	};
});

export const setZoomEndDate = pureAction<UiState, [Date | null]>((end) => (state) => {
	// @ts-expect-error - TS2339 - Property 'startValue' does not exist on type 'ZoomState'.
	if (state.zoomState.startValue == null && end == null) {
		return {
			zoomState: {
				type: 'none',
			},
			quickFilter: QUICK_DATE_FILTER_ALL_TIME,
		};
	}

	return {
		zoomState: {
			type: 'value',
			// @ts-expect-error - TS2339 - Property 'startValue' does not exist on type 'ZoomState'. | TS2339 - Property 'startValue' does not exist on type 'ZoomState'.
			startValue: state.zoomState.startValue != null ? state.zoomState.startValue : null,
			endValue: end != null ? end.getTime() : null,
		},
		quickFilter: QUICK_DATE_FILTER_CUSTOM,
	};
});

export const setQuickDateFilter = pureAction<UiState, [QUICK_DATE_FILTER]>(
	(quickFilter) => (state) => ({
		quickFilter,
		zoomState: getQuickDateFilterZoomState(state.zoomState, quickFilter, new Date()),
	}),
);
